import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';

import { type ProjectFolder } from '$/services/usecases/projects/mapper/editorProject';
import { type ProjectOverviewItem } from '$/services/usecases/projects/mapper/projectOverview';

type ProjectModalMode =
  | 'deleteProject'
  | 'renameProject'
  | 'createProjectFolder'
  | 'editProjectFolder'
  | 'deleteProjectFolder';

type ProjectModalProps = {
  isOpen: boolean;
  modalMode: ProjectModalMode;
  project: ProjectOverviewItem | null;
  projectFolder: ProjectFolder | null;
  onClose: () => void;
  onOpen: (
    mode: ProjectModalMode,
    projectOrFolder?: {
      project?: ProjectOverviewItem;
      projectFolder?: ProjectFolder;
    },
  ) => void;
};

const store = create<ProjectModalProps>()((set) => ({
  isOpen: false,
  modalMode: 'deleteProject',
  project: null,
  projectFolder: null,
  onClose: () => {
    set({ isOpen: false, project: null, projectFolder: null });
  },
  onOpen: (mode, { project = null, projectFolder = null } = {}) =>
    set({ modalMode: mode, isOpen: true, project, projectFolder }),
}));

export const useProjectModal = createSelectorHooks(store);
